module.exports = __webpack_public_path__ + "bac7db193a459faafbbb9f8911d476c0.pdf";